<template>
  <div class="ex-home">
    <div class="eh-top">
      <div class="eh-top-l">
        <div class="logo">
          <img :src="company.logo" v-if="company.logo" />
          <img src="@assets/img/empty.png" v-else />
        </div>
        <div class="info">
          <div class="info-title">{{company.nameEn}}</div>
          <div class="info-txt" v-if="boothinfo[0].Hall || boothinfo[0].Code">
            Booth Number：
            <span v-for="(booth, i) in boothinfo" :key="'booth-' + i">
              {{booth.Hall || ''}}<template v-if="booth.Hall">-</template>{{booth.Code}}
              <span v-if="(booth.Hall && booth.Code) && (i !== (boothinfo.length - 1))">,</span>
            </span>
          </div>
          <span @click="linkTo('comp')" class="info-edit">Modify</span>
        </div>
      </div>
      <div class="eh-top-r">
        <div class="ex-select">Welcome to the exhibition center {{exhibition.nameEn}}</div>
        <i class="icon iconfont icon-xiala"></i>
        <p v-if="dateType === 1">
          <span>{{dateCount}}</span> days to go
        </p>
        <p v-if="dateType === 2">正在开展</p>
        <p v-if="dateType === 3">展会已结束</p>
      </div>
    </div>
    <div class="eh-content" style="padding-top:34px">
      <Row :gutter="30">
        <Col :md="12" :xl="8" :xxl="6" v-for="(item, index) in [1,1,1,1]" :key="'releaseInt-' + index" class="w-20">
        <!-- 项目 -->
        <div class="addPro pro" v-if="index == 0">
          <h3>Exhibitor backlog</h3>
          <span @click="linkView">Click to view</span>
          <p v-if="ComFinish && ComFinish.unfinishedCount>0">{{ComFinish.unfinishedCount}} to be completed</p>
        </div>
        <!-- 公司主页 -->
        <div class="pro" v-if="index == 1 && false">
          <div class="pro-top" @click="linkTo('comp')">
            Company homepage
            <i class="icon iconfont icon-xiala"></i>
          </div>
          <div class="pro-bot comp-bot">
            <div class="comp-msg comp-msg-t" style="width:100%;">
              <h4 v-if="homeMsg">{{ homeMsg.viewCount > 9999 ? (Math.floor(homeMsg.viewCount/1000)/10) + 'W' : homeMsg.viewCount}}</h4>
              <h4 v-else>0</h4>
              <span>Pageviews</span>
            </div>
            <div class="comp-msg">
              <h4 v-if="homeMsg">{{ homeMsg.userCount > 9999 ? (Math.floor(homeMsg.userCount/1000)/10) + 'W' : homeMsg.userCount}}</h4>
              <h4 v-else>0</h4>
              <span>Visitors</span>
            </div>
            <div class="comp-msg">
              <h4 v-if="homeMsg">{{ homeMsg.followCount > 9999 ? (Math.floor(homeMsg.followCount/1000)/10) + 'W' : homeMsg.followCount}}</h4>
              <h4 v-else>0</h4>
              <span>Attention</span>
            </div>
            <!-- <div class="comp-msg">
                <h4
                  v-if="homeMsg"
                >{{ homeMsg.commentCount > 9999 ? (Math.floor(homeMsg.commentCount/1000)/10) + 'W' : homeMsg.commentCount}}</h4>
                <h4 v-else>0</h4>
                <span>留言数</span>
              </div> -->
          </div>
        </div>
        <!-- 产品信息 -->
        <div class="pro" v-if="index == 2 && false">
          <div class="pro-top" @click="linkTo('pro')">
            Product information
            <i class="icon iconfont icon-xiala"></i>
          </div>
          <div class="pro-bot hpro-bot">
            <div class="hpro-bot-c">
              <div class="hpro-bot-c-l">{{proMsg ? proMsg.count : 0}}</div>
              <div class="hpro-bot-c-r">
                <p>
                  <span>
                    <template v-if="tagCounts">
                      <template v-if="Object.keys(tagCounts)[0] === '首发新品'">
                        New release
                      </template>
                      <template v-if="Object.keys(tagCounts)[0] === '爆款'">
                        Hot sales
                      </template>
                      <template v-if="Object.keys(tagCounts)[0] === '好物'">
                        Good stuff
                      </template>
                    </template>
                  </span>
                  {{proMsg ? tagCounts[Object.keys(tagCounts)[0]] : 0}}
                </p>
                <p>
                  <span>
                    <template v-if="tagCounts">
                      <template v-if="Object.keys(tagCounts)[1] === '首发新品'">
                        New release
                      </template>
                      <template v-if="Object.keys(tagCounts)[1] === '爆款'">
                        Hot sales
                      </template>
                      <template v-if="Object.keys(tagCounts)[1] === '好物'">
                        Good stuff
                      </template>
                    </template>
                  </span>
                  {{proMsg ? tagCounts[Object.keys(tagCounts)[1]] : 0}}
                </p>
              </div>
            </div>
            <div class="hpro-bot-t">
              <div class="t-li">
                <span>Visitors</span>
                <span>{{proMsg ? proMsg.viewCount : 0}}</span>
              </div>
              <div class="t-li t-li-c" @click="linkProMes" style="cursor:pointer;">
                <span>Messages</span>
                <span>{{proMsg ? proMsg.commentCount : 0}}</span>
              </div>
              <div class="t-li">
                <span>Sharing</span>
                <span>{{proMsg ? proMsg.shareCount : 0}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 活动信息 -->
        <div class="pro" v-if="index == 3 && false">
          <div class="pro-top" @click="linkTo('act')">
            Activity information
            <i class="icon iconfont icon-xiala"></i>
          </div>
          <div class="pro-bot hpro-bot">
            <div class="hpro-bot-c">
              <div class="hpro-bot-c-l">{{actMsg ? actMsg.count : 0}}</div>
              <div class="hpro-bot-c-r">
                <!-- <p>
                    <span>Processing</span>
                    {{actMsg ? actMsg.processingCount : 0}}
                  </p>
                  <p>
                    <span>已完成</span>
                    {{actMsg ? actMsg.completedCount : 0}}
                  </p> -->
                <span>will be displayed on Bakery China mini program and Visitor Center</span>
              </div>
            </div>
            <div class="hpro-bot-t">
              <div class="t-li">
                <span>Visitors</span>
                <span>{{actMsg ? actMsg.viewCount : 0}}</span>
              </div>
              <div class="t-li t-li-c" @click="linkActMes" style="cursor:pointer;">
                <span>Messages</span>
                <span>{{actMsg ? actMsg.commentCount : 0}}</span>
              </div>
              <div class="t-li">
                <span>Sharing</span>
                <span>{{actMsg ? actMsg.shareCount : 0}}</span>
              </div>
            </div>
          </div>
        </div>
        </Col>
        <template v-if="ComFinish && ComFinish.items">
          <Col :md="12" :xl="8" :xxl="6" v-for="(item, index) in ComFinish.items" :key="'item' + index" class="w-20">
          <!-- 项目信息 -->
          <div class="pro" :class="item.stateId !== 1 ? 'pro-no' :'pro-over'">
            <div class="pro-top" @click="linkToPro(item)">
              {{item.nameEn}}
              <div style="flex:1" class="flex-bxo">
                <template v-if="item.finishType !== -10 && item.finishType !== 11">
                  <span v-if="item.stateId == 1" style="color: #009944;">Submitted</span>
                  <span v-if="item.stateId == -1" style="color: #999;">Not submitted</span>
                  <span v-if="item.stateId == 0" style="color: #fe781d;">Processing</span>
                </template>
                <i class="icon iconfont icon-xiala"></i>
              </div>
            </div>
            <div class="pro-bot common-bot">
              <p>
                {{item.introductionEn}}
                <span class="exist" v-if="item.link" @click="linkTo2(item.link)">details</span>
              </p>
              <span class="type-1" v-if="item.stateId == 1">
                <img src="@/assets/img/home-over.png">
              </span>
              <span class="type-3" v-if="item.stateId == 1">Will be displayed on My Cloud Booth</span>
              <span class="type-2" v-if="item.stateId !== 1 && item.stopTime">Due date is {{item.stopTime | moment("YYYY/MM/DD")}}</span>
            </div>
          </div>
          <!-- <div class="pro">
            <div class="pro-top" @click="linkToPro(item)">
              {{item.nameEn}}
              <i class="icon iconfont icon-xiala"></i>
            </div>
            <div class="pro-bot common-bot" v-if="false"> 
              <span class="type-1" v-if="item.stateId == 0">Processing</span>
              <span class="type-2" v-if="item.stateId == -1">Not submitted</span>
              <span class="type-2" v-if="item.stateId == 1">Submitted</span>
              <p v-if="item.stateId == 1" style="color:#333;">Will be displayed on My Cloud Booth</p>
              <p v-if="item.stateId !== 1 && item.stopTime">Due date is {{item.stopTime | moment("YYYY/MM/DD")}}</p>
            </div>
          </div> -->
          </Col>
        </template>
      </Row>
    </div>
    <iModal v-model="infoTip" width="700" :closable="false" footer-hide class-name="info-Tip">
      <p class="tip">Welcome to the</p>
      <p class="tip">{{exhibition.nameEn}} Exhibition Center</p>
      <p class="tip">please complete your exhibiting information</p>
      <div style="position:relative;width:100%;height:40px;margin-top:30px;">
        <p class="tip-btn" @click="$router.push('/exhibitionEn/index/companyInfo')">Start</p>
      </div>
    </iModal>
  </div>
</template>

<script>
import config from '@assets/config.json'; // api 请求json 
import { mapGetters, mapActions } from "vuex";
export default {
  name: "exhibition-home",
  data () {
    return {
      dateType: 0, // 开展的状态 1 还未开展 2 正在开展 3已经开过展
      dateCount: 0, // 距离开展天数
      homeMsg: null,
      proMsg: null,
      actMsg: null,
      tagCounts: {},
      ComFinish: null,
      infoTip: false,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo"
    }),
    header () { return this.$store.state.header },
    boothinfo () {
      if (this.joinInfo && this.joinInfo.boothInfo && this.joinInfo.boothInfo.length) {
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object String]') {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Object]') {
          return [{ Hall: this.joinInfo.boothInfo.Hall, Code: this.joinInfo.boothInfo.Code }];
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Array]') {
          return [{ Hall: this.joinInfo.boothInfo[0].Hall, Code: this.joinInfo.boothInfo[0].Code }];
        }
      }
      return [{ Hall: "", Code: "" }];
    }
  },
  mounted () {
    this.getdata();
    this.getHomeMsg2();
    this.getComProcess();
  },
  created () {
    document.title = "国际焙烤展 - 首页";
    if (!this.company.businessLicenses || !this.company.logo) {
      this.infoTip = true;
    }
  },
  methods: {
    ...mapActions({
      getHomeMsg: "loginModule/getHomeMsg"
    }),
    linkView () {
      if (this.ComFinish && this.ComFinish.count > 0) {
        this.$router.push("/exhibitionEn/index/home-pro")
      } else {
        this.$Message.info('暂无项目！');
      }
    },
    getHomeMsg2 () {
      this.getHomeMsg(this.joinInfo.joinId).then(res => {
        // console.log(res)
        if (res) {
          this.homeMsg = res;
          this.proMsg = res.productCount;
          this.actMsg = res.activityCount;
          this.tagCounts = res.productCount.tagCounts;
        }
      });
    },
    getComProcess () { // 获取公司的完成进度
      this.$http.get(`/api/join/GetFinishItems?joinId=${this.joinInfo.joinId}`, this.header)
        .then(res => {
          if (res.status === 200 && res.data) {
            this.ComFinish = res.data;
            // console.log("公司完成情况：",this.ComFinish);
          }
        });
    },
    linkTo (type) {
      switch (type) {
        case "comp":
          this.$router.push("/exhibitionEn/index/companyInfo");
          break;
        case "pro":
          this.$router.push("/exhibitionEn/index/product/allpro");
          break;
        case 'act':
          this.$router.push('/exhibitionEn/index/activity/allpro');
          break;
        case "cat":
          this.$router.push("/exhibitionEn/index/exinfo/catalogue");
          break;
        case "car":
          this.$router.push("/exhibitionEn/index/exinfo/carApply");
          break;
        case "invoice":
          this.$router.push("/exhibitionEn/index/exinfo/invoice");
          break;
        case "link":
          this.$router.push("/exhibitionEn/index/companyInfo?type=link");
          break;
      }
    },
    linkToPro (item) {
      // 根据finishType字段，跳转至不同页面
      // Embellish = 11：个性化设置提示
      // Release = 12：发布商机提示
      // Product = 13：上传产品提示
      // Activity = 14：申请活动提示
      // Catalogue = 15：提交会刊提示
      // Lintel = 16：提交楣板信息提示, 
      // Vehicle = 17：申请车证提示
      // Company = 18：完善公司信息提示
      // Contact = 19：完善联系人提示
      // Invoice = 20：完善开票信息提示
      // Example = 21：上传案例提示
      // Brand = 22：上传品牌提示
      // Cooperation = 23：上传合作伙伴提示
      // if (item.finishType) {
      //   switch (item.finishType) {
      //     case 11:
      //       this.$router.push("/exhibitionEn/index/exinfo/exhibition-info");
      //       break;
      //     case 12: // 商机
      //       break;
      //     case 13:
      //       this.$router.push("/exhibitionEn/index/product/allpro");
      //       break;
      //     case 14:
      //       this.$router.push("/exhibitionEn/index/activity/allpro");
      //       break;
      //     case 15:
      //       this.$router.push("/exhibitionEn/index/exinfo/catalogue");
      //       break;
      //     case 16:
      //       this.$router.push("/exhibitionEn/index/exinfo/fascia-board");
      //       break;
      //     case 17:
      //       this.$router.push("/exhibitionEn/index/exinfo/carApply");
      //       break;
      //     case 18:
      //       this.$router.push("/exhibitionEn/index/companyInfo?type=basic");
      //       break;
      //     case 19:
      //       this.$router.push("/exhibitionEn/index/companyInfo?type=link");
      //       break;
      //     case 20:
      //       this.$router.push("/exhibitionEn/index/exinfo/invoice");
      //       break;
      //     case 21:
      //       this.$router.push("/exhibitionEn/index/case/all");
      //       break;
      //     case 22:
      //       this.$router.push("/exhibitionEn/index/brand/allbrand");
      //       break;
      //     case 23:
      //       this.$router.push("/exhibitionEn/index/partner/allpartner");
      //       break;
      //   }
      // }
    },
    linkTo2 (item) {
      window.open(item);
    },
    getdata () {
      const todady = new Date().getTime(); // 当前时间戳
      const StartDate = this.exhibition
        ? new Date(this.exhibition.startTime).getTime()
        : 0; // 展会开始时间
      const EndDate = this.exhibition
        ? new Date(this.exhibition.endTime).getTime() + 24 * 3600 * 1000
        : 0; // 展会结束时间
      const date = EndDate - todady; // (结束-当前)
      const date2 = StartDate - todady; // (开始-当前)
      if (date < 0) {
        this.dateCount = -1; //
        this.dateType = 3; // 展会已经举办
      }
      if (date2 < 0 && date > 0) {
        // 正在开展
        this.dateType = 2;
      }
      if (date2 > 0) {
        // 还未开展
        this.dateType = 1;
        this.dateCount = Math.floor(date2 / (24 * 3600 * 1000)); // 距离开展还有多少天
      }
    },
    linkProMes () {
      this.$router.push("/exhibitionEn/index/product/allpro?type=mes");
    },
    linkActMes () {
      this.$router.push("/exhibitionEn/index/activity/allpro?type=mes");
    }
  }
};
</script>

<style scoped lang="scss">
.ex-home {
  width: 100%;
  height: 120px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  padding: 27px 24px 0 24px;
  .eh {
    &-top {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &-l {
        width: 50%;
        display: flex;
        align-items: center;
        .logo {
          width: 64px;
          height: 64px;
          border: 1px solid #d8d8d8;
          border-radius: 5px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          padding-left: 20px;
          position: relative;
          max-width: calc(100% - 100px);
          &-title {
            font-size: 18px;
            color: #333;
            font-weight: bold;
            margin-bottom: 10px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &-txt {
            font-size: 12px;
            color: #4d4d4d;
          }
          &-edit {
            position: absolute;
            right: -40px;
            top: 4px;
            font-size: 14px;
            color: #b10042;
            cursor: pointer;
          }
        }
      }
      &-r {
        width: 50%;
        position: relative;
        text-align: right;
        .ex-select {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          text-align: right;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 20px;
          cursor: pointer;
        }
        i {
          position: absolute;
          right: 0;
          top: 0;
          color: #333;
          font-weight: bold;
          cursor: pointer;
        }
        p {
          font-size: 14px;
          color: #333;
          text-align: right;
          line-height: 28px;
          span {
            font-size: 18px;
          }
        }
      }
    }
    &-content {
      .addPro {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h3 {
          font-size: 24px;
          line-height: 48px;
          color: #333;
        }
        span {
          display: block;
          width: 112px;
          height: 32px;
          background-color: #b10042;
          border-radius: 4px;
          line-height: 32px;
          color: #fff;
          font-size: 14px;
          margin: 30px auto 0;
          cursor: pointer;
        }
        p {
          font-size: 14px;
          line-height: 24px;
          padding-top: 5px;
          color: #ff0000;
        }
      }
      .pro-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 52px;
        font-size: 16px;
        color: #262626;
        padding: 0 24px;
        border-bottom: 1px solid #e8e8e8;
        cursor: pointer;
        i {
          display: block;
          transform: rotate(-90deg);
        }
      }
      .pro-bot {
        padding: 24px;
      }
      .comp-bot {
        display: flex;
        flex-wrap: wrap;
        .comp-msg {
          width: 50%;
          h4 {
            font-size: 36px;
            color: #333;
            line-height: 40px;
            padding-bottom: 10px;
            font-weight: 100;
          }
          span {
            font-size: 18px;
            color: #666;
          }
        }
        .comp-msg-t {
          margin-bottom: 40px;
        }
      }
      .hpro-bot {
        &-c {
          display: flex;
          align-items: center;
          min-height: 108px;
          &-l {
            width: 45%;
            font-size: 60px;
            line-height: 48px;
            color: #333;
            margin-right: 5%;
            text-align: center;
          }
          &-r {
            p {
              font-size: 36px;
              color: #333;
              display: flex;
              align-items: center;
              span {
                font-size: 14px;
                color: #666;
                margin-right: 16px;
              }
            }
          }
        }
        &-t {
          display: flex;
          justify-content: space-around;
          align-items: center;
          margin-top: 24px;
          .t-li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;
            span:first-child {
              font-size: 14px;
              color: #666;
              padding-bottom: 14px;
            }
            span:last-child {
              font-size: 18px;
              color: #333;
            }
          }
          .t-li-c {
            border-left: 1px solid #e6e6e6;
            border-right: 1px solid #e6e6e6;
          }
        }
      }
    }
  }
}
/deep/ .info-Tip {
  .ivu-modal {
    top: 300px;
  }
  .ivu-modal-content {
    background-color: rgb(126, 0, 0);
    border-radius: 30px;
  }
  .ivu-modal-body {
    background-color: rgb(126, 0, 0);
    border-radius: 30px;
    padding: 60px 16px 40px;
  }
  .tip {
    text-align: center;
    font-size: 24px;
    color: #fff;
    font-weight: bold;
  }
  .tip-btn {
    position: absolute;
    left: 50%;
    margin-left: -90px;
    width: 180px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    background-color: rgb(64, 64, 64);
    font-size: 24px;
    cursor: pointer;
    border-radius: 10px;
  }
}
.ivu-dropdown {
  text-align: center;
}
/deep/.eh-top-r {
  .ivu-select-dropdown {
    left: 473px;
    width: auto;
  }
}
.pro {
  height: 260px;
  background-color: #fafafa;
  box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
  margin-bottom: 24px;
}
.pro-no {
  background-color: #fff;
  .pro-top {
    color: #333;
  }
  .common-bot {
    p {
      color: #333;
    }
  }
}
.pro-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  font-size: 16px;
  color: #999;
  padding: 0 24px;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  span {
    display: block;
    color: #009944;
    font-size: 16px;
  }
}
.pro-bot {
  padding: 12px 24px 24px 24px;
  height: 208px;
}
.common-bot {
  position: relative;
  p {
    max-height: 132px;
    font-size: 14px;
    color: #999;
    line-height: 2;
  }
  .type-1 {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
  .type-2 {
    position: absolute;
    right: 20px;
    bottom: 10px;
    color: #ff0000;
  }
  .type-3 {
    width: 100%;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 10px;
    color: #333;
  }
}
.exist {
  font-size: 14px;
  color: #1890ff;
  z-index: 1000;
  &:hover {
    cursor: pointer;
  }
}
.flex-bxo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
